// @ts-check
import { createDataGridContext } from '~/components/Shared/ZeroDataGrid/ZeroDataGrid.context';
import { useContext } from "react";

const [ScheduleDataGridContext, ScheduleDataGridContextProvider] = createDataGridContext('schedules');
export { ScheduleDataGridContext, ScheduleDataGridContextProvider };

/** @returns {BaseDataGridContextValue} */
export function useScheduleDataGridContext() {
    return useContext(ScheduleDataGridContext);
} 